// extracted by mini-css-extract-plugin
export var errorIcon = "_lm-1";
export var nameLogo = "_lm-0";